import { assign } from 'xstate';

import { FlowConsumerContextEnergy } from '../../context';

const resetValues = (currentValues: FlowConsumerContextEnergy): FlowConsumerContextEnergy => {
  const data: FlowConsumerContextEnergy = {};

  const { hasSolarPanels } = currentValues;

  if (!hasSolarPanels) {
    data.solarPanelsOutput = undefined;
  }

  return data;
};

export const resetSolarPanelsOutput = assign(({ context }) => {
  return { ...context, ...resetValues({ ...context }) };
});
